<app-navbar></app-navbar>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
